// extracted by mini-css-extract-plugin
export var gif = "_gm-0";